module.exports = __webpack_public_path__ + "img/Webで学ぶ JavaScript 2020_2_4_3.3a723743.jpeg";